import { Link } from "@tanstack/react-router";

interface Props {
  slug: string;
  image: string;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
}

export function ArticleCard({ slug, image, category, title, excerpt, date, readTime }: Props) {
  return (
    <Link
      to="/blog/$slug"
      params={{ slug }}
      className="group flex flex-col overflow-hidden rounded-2xl border transition-all hover:shadow-sm"
      style={{ backgroundColor: "var(--color-background)", borderColor: "var(--color-border)" }}
    >
      <div className="aspect-[16/10] overflow-hidden">
        <img
          src={image}
          alt={title}
          loading="lazy"
          width={1024}
          height={640}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <span
          className="self-start rounded-full px-3 py-1 text-[11px] uppercase tracking-[0.18em]"
          style={{ backgroundColor: "var(--color-sage-light)", color: "var(--color-dark)" }}
        >
          {category}
        </span>
        <h3 className="mt-4 font-display text-2xl font-normal leading-tight">{title}</h3>
        <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--color-text)" }}>{excerpt}</p>
        <div className="mt-5 flex items-center justify-between text-xs" style={{ color: "var(--color-muted-foreground)" }}>
          <span>{date} · {readTime}</span>
          <span className="transition-transform group-hover:translate-x-1">Lire →</span>
        </div>
      </div>
    </Link>
  );
}
